import { useEffect, useState } from "react";

function useLockedBody(initialLocked = false) {
  const [locked, setLocked] = useState(initialLocked);

  // Do the side effect before render
  useEffect(() => {
    if (!locked) {
      return;
    }

    // Save scroll position
    const scrollPosition = window.scrollY;

    // Save initial body style
    const originalBodyOverflow = document.body.style.overflow;
    const originalBodyPaddingRight = document.body.style.paddingRight;
    const originalDocumentElementOverflow =
      document.documentElement.style.overflow;

    // Lock body scroll
    document.body.style.position = "absolute";
    document.body.style.overflow = "hidden";

    // Get the scrollBar width
    const root = document.getElementById("___gatsby"); // or root
    const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;

    // Avoid width reflow
    if (scrollBarWidth) {
      document.body.style.paddingRight = `${scrollBarWidth}px`;
    }

    return () => {
      document.documentElement.style.overflow = originalDocumentElementOverflow;
      document.body.style.overflow = originalBodyOverflow;

      if (scrollBarWidth) {
        document.body.style.paddingRight = originalBodyPaddingRight;
      }

      if (scrollPosition) {
        window.scrollTo(0, scrollPosition);
      }
    };
  }, [locked]);

  // Update state if initialValue changes
  useEffect(() => {
    if (locked !== initialLocked) {
      setLocked(initialLocked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLocked]);

  return [locked, setLocked];
}

export default useLockedBody;
